<mat-menu #childMenu="matMenu" [overlapTrigger]="false">
  <span *ngFor="let child of items">
    <!-- Handle branch node menu items -->
    <span *ngIf="child.children && child.children.length > 0">
      <button mat-menu-item color="primary" [matMenuTriggerFor]="menu.childMenu">
        {{child.displayName}}
      </button>
      <Teranet-MenuItem #menu [items]="child.children"></Teranet-MenuItem>
    </span>
    <!-- Handle leaf node menu items -->
    <span *ngIf="!child.children || child.children.length === 0">
      <a mat-menu-item [routerLink]="child.route">
        {{child.displayName}}
      </a>
    </span>
  </span>
</mat-menu>
